import { Injectable, Inject } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class AdaptersService {

    //conv dd/mm/yyyy to timestamp
    toTimeStamp1(dateString) {

        var d = moment(dateString, 'DD/MM/YYYY');

        if (d.isValid()) {
            if (dateString == null || dateString == undefined)
                return null;
            else {
                let [day, month, year] = dateString.split('/');
                dateString = month + '/' + day + '/' + year;
                return (new Date(dateString)).getTime();
            }
        }
        else {
            return dateString;
        }
    }
    //conv timestamp to dd/mm/yyyy
    formattedDate1(t) {
        var date = moment(t, 'DD/MM/YYYY');

        if (!date.isValid()) {
            if (t) {
                var d = new Date(t);
                return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
            }
        }
        else {
            return t;
        }
    }

    //conv dd/mm/yyyy to timestamp
    toTimeStamp(dateString) {

        if (dateString) {
            var d = moment(dateString, ['DD/MM/YYYY', 'x']);
            return d.valueOf()
        }
        else
            return null
    }
    //conv timestamp to dd/mm/yyyy
    formattedDate(dateString) {

        if (dateString && dateString != null) {
            // var d = moment(dateString, ['DD/MM/YYYY', 'x']);
            var d = moment(dateString);
            return d.format('DD/MM/YYYY');
        }
        else
            return null
    }

    transformLeadSaveRequest(req) {
        if (req.clientDO.personDO != null && req.clientDO.personDO.dateOfBirth != null) {
            req.clientDO.personDO.dateOfBirth = this.toTimeStamp(req.clientDO.personDO.dateOfBirth);
        }
        req.leadDO.leadActivityDOList.forEach(leadActivity => {
            leadActivity.scheduledDt = this.toTimeStamp(leadActivity.scheduledDt);
        });
        return req;
    }

    transformLeadEditRequest(req) {
        if (req.clientDO.personDO != null && req.clientDO.personDO.dateOfBirth != null) {
            req.clientDO.personDO.dateOfBirth = this.formattedDate(req.clientDO.personDO.dateOfBirth);
        }
        req.leadDO.leadActivityDOList.forEach(leadActivity => {
            leadActivity.scheduledDt = this.formattedDate(leadActivity.scheduledDt);
        });
        return req;
    }


    transformLeadActivitySaveRequest(req) {
        // req.clientDO.personDO.dateOfBirth = this.toTimeStamp(req.clientDO.personDO.dateOfBirth);
        req.leadDO.leadActivityDOList.forEach(leadActivity => {
            leadActivity.scheduledDt = this.toTimeStamp(leadActivity.scheduledDt);
        });
        return req;
    }

    transformLeadActivityEditRequest(req) {
        // req.clientDO.personDO.dateOfBirth = this.formattedDate(req.clientDO.personDO.dateOfBirth);
        req.leadDO.leadActivityDOList.forEach(leadActivity => {
            leadActivity.scheduledDt = this.formattedDate(leadActivity.scheduledDt);
        });
        return req;
    }



    transformQuoteSaveRequest(req) {
        req.quotationContainerDO.quotationList.forEach(quotation => {
            if (quotation.policyCommencementDt != null)
                quotation.policyCommencementDt = this.toTimeStamp(quotation.policyCommencementDt);
            if (quotation.policyExpiryDt != null)
                quotation.policyExpiryDt = this.toTimeStamp(quotation.policyExpiryDt);
            if (quotation.dueDt != null)
                quotation.dueDt = this.toTimeStamp(quotation.dueDt);
        });
        req.quotationContainerDO.quotationList.forEach(quotation => {
            quotation.quotationCoverageList.forEach(quotationCov => {
                if (quotationCov.commencementDt != null)
                    quotationCov.commencementDt = this.toTimeStamp(quotationCov.commencementDt);
                if (quotationCov.expiryDt != null)
                    quotationCov.expiryDt = this.toTimeStamp(quotationCov.expiryDt);

                quotationCov.quotationCoverageScheduleList.forEach(schedule => {
                    if (schedule.commencementDt != null)
                        schedule.commencementDt = this.toTimeStamp(schedule.commencementDt);

                    if (schedule.expiryDt != null)
                        schedule.expiryDt = this.toTimeStamp(schedule.expiryDt);
                })
            });
        });
        if (req.clientDOs != null && req.clientDOs.length > 0) {
            req.clientDOs.forEach(client => {
                if (client.personDO != null && client.personDO.dateOfBirth != null)
                    client.personDO.dateOfBirth = this.toTimeStamp(client.personDO.dateOfBirth);
            });
        }
        // req.quotationContainerDO.quotationList.forEach(quotation => {
        //     quotation.policyExpiryDt = this.toTimeStamp(quotation.policyExpiryDt);
        // });

        // req.quotationIO.quotationContainerDO.quotationList[0].policyCommencementDt
        //     = this.toTimeStamp(req.quotationIO.quotationContainerDO.quotationList[0].policyCommencementDt);
        return req;
    }

    // transformTravelQuoteSaveRequest(req) {
    //     req.quotationContainerDO.quotationList.forEach(quotation => {
    //         quotation.policyCommencementDt = this.toTimeStamp(quotation.policyCommencementDt);

    //     });

    //     req.quotationContainerDO.quotationList.forEach(quotation => {
    //         quotation.policyExpiryDt = this.toTimeStamp(quotation.policyExpiryDt);

    //     });


    //     return req;
    // }



    transformQuoteEditRequest(req) {
        // req.quotationContainerDO.quotationList[0].policyCommencementDt
        //     = this.formattedDate(req.quotationContainerDO.quotationList[0].policyCommencementDt);
        // req.quotationContainerDO.quotationList[0].policyExpiryDt
        //     = this.formattedDate(req.quotationContainerDO.quotationList[0].policyExpiryDt);

        req.quotationContainerDO.quotationList.forEach(quotation => {
            if (quotation.policyCommencementDt != null)
                quotation.policyCommencementDt = this.formattedDate(quotation.policyCommencementDt);
            if (quotation.policyExpiryDt != null)
                quotation.policyExpiryDt = this.formattedDate(quotation.policyExpiryDt);
        });
        req.quotationContainerDO.quotationList.forEach(quotation => {
            quotation.quotationCoverageList.forEach(quotationCov => {
                if (quotationCov.commencementDt != null)
                    quotationCov.commencementDt = this.formattedDate(quotationCov.commencementDt);
                if (quotationCov.expiryDt != null)
                    quotationCov.expiryDt = this.formattedDate(quotationCov.expiryDt);

                quotationCov.quotationCoverageScheduleList.forEach(schedule => {
                    if (schedule.commencementDt != null)
                        schedule.commencementDt = this.formattedDate(schedule.commencementDt);

                    if (schedule.expiryDt != null)
                        schedule.expiryDt = this.formattedDate(schedule.expiryDt);
                })
            });
        });

        if (req.clientDOs != null && req.clientDOs.length > 0) {
            req.clientDOs.forEach(client => {
                if (client.personDO != null && client.personDO.dateOfBirth != null) {
                    // if (client.personDO.dateOfBirth != null)
                    client.personDO.dateOfBirth = this.formattedDate(client.personDO.dateOfBirth);
                }
            });
        }
        return req;
    }

    transformEappSaveRequest(req) {
        req.proposalDO.policyCommencementDt = this.toTimeStamp(req.proposalDO.policyCommencementDt);
        req.proposalDO.policyExpiryDt = this.toTimeStamp(req.proposalDO.policyExpiryDt);

        req.proposalDO.proposalCoverages.forEach(policyCov => {
            policyCov.commencementDt = this.toTimeStamp(policyCov.commencementDt);
            policyCov.expiryDt = this.toTimeStamp(policyCov.expiryDt);
        });

        if (req.clientDOs != null && req.clientDOs.length > 0) {
            req.clientDOs.forEach(client => {
                if (client.personDO != null && client.personDO.dateOfBirth != null) {
                    client.personDO.dateOfBirth = this.toTimeStamp(client.personDO.dateOfBirth);
                }
            });
        }
        // req.clientDOs[0].personDO.dateOfBirth = this.toTimeStamp(req.clientDOs[0].personDO.dateOfBirth);
        // req.clientDOs[1].personDO.dateOfBirth = this.toTimeStamp(req.clientDOs[1].personDO.dateOfBirth);
        return req;
    }


    transformEappEditRequest(req) {
        req.proposalDO.policyCommencementDt = this.formattedDate(req.proposalDO.policyCommencementDt);
        req.proposalDO.policyExpiryDt = this.formattedDate(req.proposalDO.policyExpiryDt);

        req.proposalDO.proposalCoverages.forEach(policyCov => {
            policyCov.commencementDt = this.formattedDate(policyCov.commencementDt);
            policyCov.expiryDt = this.formattedDate(policyCov.expiryDt);
        });
        if (req.clientDOs != null && req.clientDOs.length > 0) {
            req.clientDOs.forEach(client => {
                if (client.personDO != null && client.personDO.dateOfBirth != null)
                    client.personDO.dateOfBirth = this.formattedDate(client.personDO.dateOfBirth);
            });
        }
        // req.clientDOs[0].personDO.dateOfBirth = this.formattedDate(req.clientDOs[0].personDO.dateOfBirth);
        // req.clientDOs[1].personDO.dateOfBirth = this.formattedDate(req.clientDOs[1].personDO.dateOfBirth);
        return req;
    }


    // formattedDate(d = new Date) {
    //     console.log("Bhawna");
    //     let month = String(d.getMonth() + 1);
    //     let day = String(d.getDate());
    //     const year = String(d.getFullYear());

    //     if (month.length < 2) month = '0' + month;
    //     if (day.length < 2) day = '0' + day;

    //     console.log("month"+month + "day" +day);
    //     return `${month}/${day}/${year}`;
    // }

    // transformQuotationSaveRequest(req){
    //     req.quotationDO
    // }

    transformArrayEditRequest(req) {
        for (let i = 0; i < req.length; i++) {
            req[i][12] = this.formattedDate(req[i][12]);
            req[i][13] = this.formattedDate(req[i][13]);
        }
        return req;
    }




    // Following are the fleet related

    transformGroupPolicyEditRequest(req)
    {

        req.groupPolicyDO.proposalEntryDt = this.formattedDate(req.groupPolicyDO.proposalEntryDt);
        req.groupPolicyDO.proposalReceivedDt = this.formattedDate(req.groupPolicyDO.proposalReceivedDt);
        return req;
    }


    transformGroupPolicySubmitRequest(req) {

        req.groupPolicyDO.proposalEntryDt = this.toTimeStamp(req.groupPolicyDO.proposalEntryDt);
        req.groupPolicyDO.proposalReceivedDt = this.toTimeStamp(req.groupPolicyDO.proposalReceivedDt);

  
        
        if (req.clientDOs != null && req.clientDOs.length > 0) {
            req.clientDOs.forEach(client => {
                if (client.personDO != null && client.personDO.dateOfBirth != null)
                client.personDO.dateOfBirth = this.toTimeStamp(client.personDO.dateOfBirth);

            });
        }
          //console.log(JSON.stringify(req)+" ramesh end");
        return req;
    }

}